import { broadcastUpdatedDocumentation } from 'serviceWorker/broadcasts/documentations';
import {
  updateOneVersion as editDocumentationVersion,
  getOne as getOneDocumentation,
} from 'serviceWorker/db/documentations/documentations';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { get as getCurrentProject } from 'serviceWorker/db/selectedProject';
import {
  DocumentationEntity,
  DocumentationVersionChangesOutDto,
} from 'serviceWorker/repository/documentation/entity';
import { documentationVersionEditModelToChanges } from 'serviceWorker/repository/documentation/mappings';
import { DocumentationVersionEditModel } from 'shared/domain/documentation/documentationModel';
import { EditDocumentationVersionUseCase } from 'shared/domain/documentation/editDocumentationVersion';
import {
  HttpRequestModelType,
  HttpRequestStatus,
  __HttpRequestModel__,
} from 'shared/domain/httpRequest/httpRequestModel';
import { debugLog } from 'shared/logger/debugLog';
import { Identificable } from 'shared/types/commonView';

class DocumentationVersionEditor
  implements EditDocumentationVersionUseCase
{
  constructor(
    private editDocumentationVersion: (
      localId: number,
      versionId: string,
      changes: DocumentationVersionChangesOutDto
    ) => Promise<number>,
    private addRequest: (request: __HttpRequestModel__) => Promise<any>,
    private getCurrentProject: () => Promise<Identificable | undefined>,
    private getOneDocumentation: (
      id: number
    ) => Promise<DocumentationEntity | undefined>,
    private broadcastDocumentationUpdated: (documentation: number) => void
  ) {}
  async execute(
    documentationVersionEditModel: DocumentationVersionEditModel
  ): Promise<void> {
    debugLog(
      'EditDocumentationVersionUseCase',
      documentationVersionEditModel
    );
    const localId = documentationVersionEditModel.localId;
    const currentDocumentation = await this.getOneDocumentation(localId);

    if (!currentDocumentation) {
      throw new Error(`Cannot find documentation ${localId}`);
    }

    const documentationVersionChanges: DocumentationVersionChangesOutDto =
      documentationVersionEditModelToChanges(
        documentationVersionEditModel
      );

    await this.editDocumentationVersion(
      localId,
      documentationVersionEditModel.versionId,
      documentationVersionChanges
    );

    const currentProject = await this.getCurrentProject();
    await this.addRequest({
      createdAt: Date.now(),
      method: 'PUT',
      data: {
        localId,
        projectId: currentProject?._id,
        versionId: documentationVersionEditModel.versionId,
        changes: documentationVersionChanges,
      },
      entityType: HttpRequestModelType.documentationVersion,
      status: HttpRequestStatus.NEW,
    });

    this.broadcastDocumentationUpdated(localId);
  }
}

export const documentationVersionEditor = new DocumentationVersionEditor(
  editDocumentationVersion,
  addRequest,
  getCurrentProject,
  getOneDocumentation,
  broadcastUpdatedDocumentation
);
